<template>
  <!--  
        Usage: 
        
        this.$store.commit('setFeedback', { 
          title:'', 
          msg: '', 
          type:'', 
          action: '',
          id_bet: '' (if action printBet )
        })
      
      // title = string
      // msg = string
      // type = string ('success', 'warning', 'error', 'info')
      // action = string ('login', 'refresh', printer, 'printBet') 
  -->

  <v-dialog v-model="dialog" max-width="600">
    <v-card light>
      <v-toolbar max-height="64" elevation="0" class="transparent">
        <v-toolbar-title>{{ feedback.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Msg -->
      <v-card-text class="px-4 pb-0">
        <v-alert :type="feedback.type" prominent>{{ feedback.msg }}</v-alert>
      </v-card-text>

      <!-- <v-divider></v-divider> -->
      <!-- Buttons Actions -->
      <v-card-actions class="pa-4">
        <div class="flex-grow-1"></div>
        <!-- <v-btn text @click="dialog = !dialog">FECHAR</v-btn> -->

        <!--  
          ##
          ## ACTIONS (Personalizados)
          ##
        -->

        <!-- 
          Action: Share WhatsApp 
        -->
        <v-btn
          depressed
          class="success"
          v-if="feedback.whatsapp === true && feedback.id_bet"
          :href="whatsappUrl"
          target="_blank"
          @click="$gtag.share('Whatsapp', 'id_bet', feedback.id_bet)"
        >
          &nbsp;WhatsApp&nbsp;
          <v-icon right>mdi-share</v-icon>
        </v-btn>

        <!-- 
          Action Redirect login page (action: 'login') 
        -->
        <v-btn
          depressed
          class="info"
          v-if="feedback.action === 'login'"
          @click="
            [
              $router.push({ name: 'Login', hash: '#loginPage' }),
              (dialog = !dialog),
            ]
          "
        >
          &nbsp;LOGIN&nbsp;
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>

        <!-- 
          Action Refresh page (action: 'refresh') 
        -->
        <v-btn
          depressed
          class="info"
          v-if="feedback.action === 'refresh'"
          @click="[$router.go(''), (dialog = !dialog)]"
        >
          &nbsp;{{ $t("btnRefresh") }}&nbsp;
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <!-- 
          Action Imprimir bet (action: 'printBet') 
        -->
        <v-btn
          depressed
          class="info"
          :disabled="disabled"
          v-if="
            feedback.action === 'printBet' && !$vuetify.breakpoint.smAndDown
          "
          @click="printBet(), (disabled = true)"
        >
          {{ $t("toPrint") }} &nbsp;
          <v-icon class="ml-2">mdi-printer</v-icon>
        </v-btn>

        <!-- 
          Action Imprimir bet (action: 'printBet') 
        -->
        <v-btn
          depressed
          class="info"
          v-if="feedback.action === 'printer' && !$vuetify.breakpoint.smAndDown"
          @click="dialog = !dialog"
        >
          {{ $t("toPrint") }} &nbsp;
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <!-- 
          Action Sharebet
        -->
        <v-btn
          v-if="feedback.shareBetPDF && !isApple"
          depressed
          @click="shareBet()"
          color="red"
          style="color: white"
        >
          {{ $t("downloadPDF") }}
          <v-icon right class="ml-2">mdi-download</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "feedbackDialog",
  data: () => ({
    dialog: false,
    disabled: false,
    isApple: false,
  }),
  mounted() {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.isApple = true;
    }
  },
  computed: {
    feedback() {
      return this.$store.state.feedbackDialog;
    },
    whatsappUrl() {
      var operatorUrl = this.$store.state.operators.url;
      var msg = `https://api.whatsapp.com/send?text=Aposta%20validada:%20${this.feedback.id_bet}.%20${operatorUrl}home/conferencia/${this.feedback.id_bet}`;
      return msg;
    },
  },
  watch: {
    feedback() {
      this.dialog = true;
      this.disabled = false;
    },
  },
  methods: {
    printBet: async function () {
      if (!this.feedback.id_bet) {
        // console.warn("Envie o id da aposta!");
        return;
      }
      // No ato de imprimir é obrigatório setar 1 no printed
      // do endpoint 'agent/bets/getBetAgent'
      await this.$bet.getBetAgent(this.feedback.id_bet, 1);
      this.$printBet();
    },

    shareBet: async function () {
      this.$store.commit("setShareBet", true);
      await this.$bet.getBetAgent(this.feedback.id_bet, 1);
      this.$shareBet(); // Plugin-print.js
    },
  },
};
</script>
